<!--
// app/components/layout/TheHeader.vue
-->
<script setup lang="ts">
import Toolbar from "~/components/layout/header/Toolbar.vue";
import Navbar from "~/components/layout/header/Navbar.vue";

type Props = {
  toolbarVisible: boolean;
  isMenaLanding?: boolean;
};

withDefaults(defineProps<Props>(), {
  toolbarVisible: true,
  isMenaLanding: false,
});
</script>

<template>
  <header class="min-w-full max-w-full">
    <div class="top-0 right-0 left-0 z-50" :class="!toolbarVisible ? 'fixed' : 'static'">
      <toolbar :is-visible="toolbarVisible" :is-mena-landing="isMenaLanding"></toolbar>
      <navbar :toolbar-visible="toolbarVisible" :is-mena-landing="isMenaLanding"></navbar>
    </div>
  </header>
</template>
